module.exports = __webpack_public_path__ + "static/media/logo_circle.dc0ef861.png";